import { MessagePathNode, PathParser } from "@/shared/domain/topics";
import type {
  TopicData,
  TopicDataPathBinding,
} from "@/shared/state/visualization/schema/v1";

/**
 * Gets initial values for DataSourceSelector from existing position data
 */
export function getFileAndPath(
  topicData: TopicData | number | undefined,
): TopicDataPathBinding | undefined {
  if (!topicData || typeof topicData === "number") {
    return undefined;
  }

  const fileId = topicData.topic.association.association_id;

  const formattedMessagePath = MessagePathNode.partsToString(
    topicData.messagePath.parts,
  );
  const path = [topicData.topic.name, formattedMessagePath].join(
    PathParser.TOPIC_SEPARATOR,
  );
  return { fileId, path };
}

/**
 * Narrows position topic data to either TopicData or null.
 */
export function topicDataFor(
  value: TopicData | number | undefined,
): TopicData | undefined {
  if (!value || typeof value === "number") {
    return undefined;
  }
  return value;
}
